import * as React from "react"
import {
  Edit,
} from "react-admin"
import CategoryForm from "./CategoryForm"

const CategoryTitle = () => {
  return <span>{'商品系列'}</span>
}

const CategoryEdit = () => {
  return (
    <Edit 
      title={<CategoryTitle/>} 
      redirect={false} 
      mutationMode="optimistic"
    >
      <CategoryForm 
        formType="edit" 
      />
    </Edit>
  )
}

export default CategoryEdit